<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-purple" sprite="world-hand" />
          Providers
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-purple" sprite="world-hand" />
            Providers
          </h1>
        </el-col>

        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createVisible"
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />

    <edit-form
      :editVisible="editVisible"
      :clearFormFields="clearFormFields"
      :editProcessing="editProcessing"
      :selectedProvider="selectedProvider"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions } from "vuex";
import { ExportToCsv } from "export-to-csv";

import feathersClient from "../../../feathers/feathers-client";
import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";
import { globalEventBus } from "../../../globalEventBus";

export default {
  name: "ProvidersTable",
  data() {
    return {
      providerChannel: null,
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableLoading: false,
      tableData: [],
      allProviders: [],
      search: "",
      visibleActionsId: "",
      editVisible: false,
      createVisible: false,
      clearFormFields: false,
      selectedProvider: null,
      total: 0,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: () => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-purple" sprite="world-hand" />
                </div>
              ];
            }
          }
        },
        {
          field: "name",
          title: "Name",
          sortable: true,
          minWidth: 150
        },
        {
          field: "type",
          title: "Type",
          sortable: true,
          minWidth: 100
        },
        {
          field: "host",
          title: "Host",
          showOverflow: true,
          sortable: true,
          minWidth: 100
        },
        {
          field: "actions",
          title: "",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ];
            }
          }
        }
      ]
    };
  },

  components: {
    CreateForm,
    EditForm
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {

    user() {
      this.fetchProviders();
      if (!this.providerChannel) {
        this.joinSocketChannel();
      }
    },

    search: debounce(function() {
      this.searchProviders();
    }, 500)
  },

  methods: {

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map(item => ({
          name: item.name,
          type: item.type,
          host: item.host
        }));

        const options = {
          filename: "providers",
          showLabels: true,
          headers: ["Name", "Type", "Host"]
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchProviders() {
      if (this.search.length) {
        this.tableData = this.tableData.filter(
          data =>
            data.name.toLowerCase().includes(this.search.toLowerCase()) ||
            data.type.toLowerCase().includes(this.search.toLowerCase()) ||
            (!!data.host &&
              data.host.toLowerCase().includes(this.search.toLowerCase()))
        );
      } else {
        this.tableData = [...this.allProviders];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    openEditModal(id) {
      this.editVisible = true;
      this.clearFormFields = false;
      feathersClient
        .service("providers")
        .get(id)
        .then(res => {
          this.selectedProvider = res;
          this.editVisible = true;
        });
    },

    createOperation(createBody) {
      this.$confirm("Process provider create?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          feathersClient.service('providers').create(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("create");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      this.$confirm("Process provider edit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          feathersClient.service('providers').patch(this.selectedProvider.id, editBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited Successfully!",
                type: "success"
              });
              this.editProcessing = false;

              this.clearFormFields = true;
              this.cancelOperation("edit");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    deleteOperation(id) {
      this.$confirm("Process provider delete?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.deleteProcessing = true;

          feathersClient.service('providers').remove(id)
            .then(() => {
              this.deleteProcessing = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    fetchProviders() {
      this.tableLoading = true;
      feathersClient.service('providers').find({
        query: {
          $sort: { name: 1 }
        }
      }).then(res => {
        this.tableData = [...res];
        this.allProviders = [...res];
        this.total = res.length;
        this.tableLoading = false;
      });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "global-admins",
      };
      channelService.create(data).then(() => {
        this.providerChannel = 'global-admins';
      });
    },

    removeListeners() {
      feathersClient.service("providers").removeListener("patched");
      feathersClient.service("providers").removeListener("created");
      feathersClient.service("providers").removeListener("removed");
      globalEventBus.$off("appReconnected");
    }
  },

  created() {
    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service("providers").on("patched", data => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allProviders.findIndex(
        item => item.id === data.id
      );
      if (updateIndex >= 0) {
        this.tableData.splice(updateIndex, 1, data);
      }
      if (updateAllIndex >= 0) {
        this.allProviders.splice(updateAllIndex, 1, data);
      }
    });

    //record was created
    feathersClient.service("providers").on("created", data => {
      this.tableData.push(data);
      this.allProviders.push(data);
    });

    //record was deleted
    feathersClient.service("providers").on("removed", data => {
      const indexToRemove = this.tableData.findIndex(
        item => item.id === data.id
      );
      const indexAllToRemove = this.allProviders.findIndex(
        item => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allProviders.splice(indexAllToRemove, 1);
      }
    });
  },

  mounted() {
    if (this.user) {
      this.joinSocketChannel();
      this.fetchProviders();
    }
  },

  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.providerChannel } });
    this.removeListeners();
  }
};
</script>
